import { Feature } from 'ol';
import { createEmpty, extend } from 'ol/extent';
import { Point } from 'ol/geom';

export const getFeaturesExtent = (features: Feature[]) => {
  const cartogramExtent = createEmpty();

  features.forEach((feature: Feature) => {
    const geometry = feature.getGeometry();
    if (!geometry) return;
    extend(cartogramExtent, geometry?.getExtent());
  });

  return cartogramExtent;
};

export const isPointFeature = (value: unknown): value is Feature<Point> => {
  return value instanceof Feature && value.getGeometry() instanceof Point;
};
